import React from 'react';

const Trash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M23 27H9V13H23V27ZM7 27C7 28.1046 7.89543 29 9 29H23C24.1046 29 25 28.1046 25 27V13C26.1046 13 27 12.1046 27 11V7C27 5.89543 26.1046 5 25 5H18C18 3.89543 17.1046 3 16 3C14.8954 3 14 3.89543 14 5H7C5.89543 5 5 5.89543 5 7V11C5 12.1046 5.89543 13 7 13V27ZM16 7H25V11H23H9H7L7 7H16ZM13 17V23C13 23.5523 13.4477 24 14 24C14.5523 24 15 23.5523 15 23V17C15 16.4477 14.5523 16 14 16C13.4477 16 13 16.4477 13 17ZM18 16C17.4477 16 17 16.4477 17 17V23C17 23.5523 17.4477 24 18 24C18.5523 24 19 23.5523 19 23V17C19 16.4477 18.5523 16 18 16Z" />
  </svg>
);

export default Trash;
